import {IImportService} from "../../services/IImportService";
import {Asset} from "../../entities/Asset";
import { ImportError } from "../import/ImportError";
import { ImportColumn } from "../import/ImportColumn";
import { ServerImportField } from "./ServerImportField";
import { NotificationService } from "../../services/NotificationService";

export class ServerImportModel<T> {
    errors: ImportError[] = [];
    errorsCount: number = 0;
    importColumns: ImportColumn[] = [];
    fileId: string;
    importFields:ServerImportField[] = [];
    requiredImportFields:ServerImportField[] = [];
    optionalImportFields: ServerImportField[] = [];
    importProgress: string = "";
    importProgressPrefix: string = "";
    static $inject = ['$q'];
    constructor(public $q: ng.IQService,
        public importService: IImportService<T>,
        public notifyService: NotificationService,
        public timeout: ng.ITimeoutService) {
    }
    getColumns(): ng.IPromise<ImportColumn[]>{
        if (this.importColumns.length > 0)
            return this.$q.when(this.importColumns);
        else
            return this.importService.getImportColumns(this.fileId).then((data) => {
                this.importColumns = data;
                return this.$q.when(data);
            });
    }
    getImportFields():ng.IPromise<any>{
        if(this.importFields.length > 0)
            return this.$q.when();
        else
            return this.importService.getImportFields().then((data)=>{
                for(var i=0; i<data.length; i++) {
                    var importField:ServerImportField = ServerImportField.parseJson(data[i]);
                    if(importField.required)
                        this.requiredImportFields.push(importField);
                    else
                        this.optionalImportFields.push(importField);
                    this.importFields.push(importField);
                }
                return this.$q.when();
            });
    }
    validateImportColumns(): boolean {
        for (var i = 0; i < this.requiredImportFields.length; i++) {
            var importField: ServerImportField = this.requiredImportFields[i];
            if (importField.columnIndex === null)
                return false;
        }
        return true;
    }
    startImport(test: boolean): ng.IPromise<boolean> {        
        this.importProgressPrefix = test ? "Testing Import. " : "Importing. ";            
        this.importProgress = this.importProgressPrefix + "0% Complete";
        return this.importService.importFile(this.fileId, this.importFields, test).then((started) => {
            if (!started) {
                this.notifyService.notifyError("Couldn't start test import because another import is already running for the same file.");
                return this.$q.when(false);
            }
            return this.monitorImportProgress();
        }).catch((exc) => {
            this.notifyService.notifyError("Got error in testing import:" + exc);
            return this.$q.when(false);
        })
    }    
    getRoute(nextAction:any):string{
        return "";
    }
    getControllersName(): string {
        return "";
    }
    monitorImportProgress(): ng.IPromise<boolean> {
        return this.importService.importFileProgress(this.fileId).then((percent) => {
            this.importProgress = this.importProgressPrefix + percent + "% Complete";
            if (percent > 99) {
                return this.importService.importResults(this.fileId).then((errors) => {
                    this.errors = errors;
                    this.errorsCount = errors.length;
                    return this.$q.when(true);
                }).catch((exc) => {
                    this.notifyService.notifyError("Got error in checking import results:" + exc);
                    return this.$q.when(false);
                });
            }
            else {
                return this.timeout(() => {
                    return this.monitorImportProgress();
                }, 2000);
            }
        }).catch((exc) => {
            this.notifyService.notifyError("Got error in checking import progress:" + exc);
            return this.$q.when(false);
        });
    }
}
